module.exports = __webpack_public_path__ + "img/DNARepair-PDAC_GSE111672.e758b796.png";